import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
app.initializers.add('elated', function () {
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const tags = this.attrs.post.discussion().tags();
    if (tags.find(tag => tag.slug() === 'rubber-duck')) {
      items.remove('user');
    }
  });
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const discussion = this.attrs.discussion;
    const tags = discussion.tags();
    if (tags.find(tag => tag.slug() === 'rubber-duck')) {
      items.remove('terminalPost');
    }
  });
});